import { useEffect } from "react";

export function usePullToRefresh(onRefresh) {
	useEffect(() => {
		let startY = 0;
		let isPulling = false;
		let loader = null;

		const createLoader = () => {
			loader = document.createElement("div");
			loader.id = "pull-refresh-loader";
			loader.innerHTML = `<div class="ptr-spinner"></div>`;
			loader.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        height: 0;
        background: white;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        transition: height 0.2s ease;
        z-index: 9999;
      `;
			document.body.prepend(loader);

			const style = document.createElement("style");
			style.innerHTML = `
        .ptr-spinner {
          border: 3px solid #e0e0e0;
          border-top: 3px solid #fd7e14;
          border-radius: 50%;
          width: 28px;
          height: 28px;
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `;
			document.head.appendChild(style);
		};

		const onTouchStart = (e) => {
			if (window.scrollY === 0) {
				startY = e.touches[0].clientY;
			}
		};

		const onTouchMove = (e) => {
			const currentY = e.touches[0].clientY;
			const diff = currentY - startY;

			if (diff > 60 && window.scrollY === 0 && !isPulling) {
				isPulling = true;
				if (!loader) createLoader();
				loader.style.height = "60px";

				setTimeout(() => {
					loader.style.height = "0";
					isPulling = false;
					if (typeof onRefresh === "function") onRefresh();
				}, 1000);
			}
		};

		window.addEventListener("touchstart", onTouchStart);
		window.addEventListener("touchmove", onTouchMove);

		return () => {
			window.removeEventListener("touchstart", onTouchStart);
			window.removeEventListener("touchmove", onTouchMove);
			if (loader) loader.remove();
		};
	}, [onRefresh]);
}
